































import {
  Component, Vue, Watch, mapState,
} from '@samclick-commons';
import {
  SamclickDatatable, SamclickWrapper, SamclickTableColumn, SamclickNumber, SamclickValidation,
} from '@samclick-components';
import { parseJWT, getAuthorizationToken } from '@/utils/localstorage-util';
import SamclickButton from './forms/SamclickButton.vue';


    @Component({
      components: {
        SamclickDatatable,
        SamclickWrapper,
        SamclickTableColumn,
        SamclickNumber,
        SamclickValidation,
        SamclickButton,
      },
      computed: {
        ...mapState({
          affiliateStoreoo: (state: any) => state.affiliate.affiliateStore,
        }),
      },
    })
export default class PlayGround extends Vue {
        componentState = {
          numberOnly: 5,
          tableData: [
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
            { name: 'Sam1', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean2', mobile: '13452xxxx', sex: 1 },
            { name: 'Tony3', mobile: '187233xxxx', sex: 0 },
            { name: 'Sam4', mobile: '15299xxxx', sex: 0 },
            { name: 'Jean5', mobile: '13452xxxx', sex: 1 },
          ],
        }

        okoi(args) {
          console.log(args);
        }

        testRow(row, event, column) {
          console.log('hooray?a', row);
        }

        trip() {
          console.log('here!!!!@@');
          const aaa = [];

          if (aaa) {
            console.log('here!!!!');
          }
        }

        paginationChange(info: object) {
          this.componentState.tableData = [
            { name: `Name${info.pageIndex}`, mobile: '15299xxxx', sex: 0 },
            { name: `Name${info.pageIndex}`, mobile: '13452xxxx', sex: 1 },
            { name: `Name${info.pageIndex}`, mobile: '187233xxxx', sex: 0 },
            { name: `Name${info.pageIndex}`, mobile: '15299xxxx', sex: 0 },
            { name: `Name${info.pageIndex}`, mobile: '13452xxxx', sex: 1 },
          ];
        }

        beforeUpdate() {
          console.log(this.componentState.numberOnly, 'COMPONENT VALUE');
        }

        mounted() {

        }
}
